/**
 * Box  component
 * DEPRECATED
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";

import { BP, Type, defineElementaryComponent, createSubScope } from "@adapptio/lib-blueprint";

import {
	TViewComponentDefinition,
	TComponentReact,
	ClassList,
	Container,
	ContainerProps,
	BackgroundColorSchema,
	isEventEnabled
} from "@adapptio/lib-components";
import { termsEditor } from "../../terms";
import { BaseEvents } from "../../base/BaseEvents";

interface ComponentBox_State {}

const ComponentBox_Props = {
	...ContainerProps,

	backgroundColor: BP.Prop(
		BackgroundColorSchema({
			alias: "backgroundColor_box",
			default: "WHITE"
		}),
		ContainerProps.backgroundColor.order,
		ContainerProps.backgroundColor.group
	)
};

const ComponentBox_Events = {
	...BaseEvents
};

const ComponentBox_Definition = defineElementaryComponent<
	typeof ComponentBox_Props,
	ComponentBox_State,
	typeof ComponentBox_Events
>({
	...termsEditor.components.box.component,

	name: "box",

	category: "layout",

	icon: "mdi/card",

	docUrl: "...",

	order: 10,

	hidden: true,

	container: true,

	props: ComponentBox_Props,

	events: ComponentBox_Events,

	resolve: (spec, state) => {
		return state || {};
	},

	getScopeData: (spec, state) => {
		return {};
	},

	getScopeType: () => {
		return Type.Object({
			props: {}
		});
	}
});

const ComponentBox_React: TComponentReact<typeof ComponentBox_Definition> = ({
	props,
	componentInstance,
	reactComponentClassList
}) => {
	const { classList } = ClassList.getElementClassListAndIdClassName("cmp-box", componentInstance.safePath, {
		componentInstance,
		componentClassList: reactComponentClassList
	});

	// Event handler

	const _clickHandler = React.useMemo(() => {
		if (isEventEnabled(componentInstance.eventEnabled.click, componentInstance.componentMode)) {
			return () => componentInstance.eventTriggers.click((parentScope) => createSubScope(parentScope));
		}

		return;
	}, [
		componentInstance.componentMode,
		componentInstance.eventEnabled.click,
		componentInstance.eventTriggers.click
	]);

	return (
		<Container
			{...props}
			componentPath={componentInstance.safePath}
			componentMode={componentInstance.componentMode}
			classList={classList}
			contentModelNode={componentInstance.modelNode?.props.props.content as unknown as any}
			onClick={_clickHandler}
		/>
	);
};

export const ComponentBox: TViewComponentDefinition<typeof ComponentBox_Definition> = {
	...ComponentBox_Definition,
	reactComponent: ComponentBox_React
};
